import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './../auth/auth-guard.service';
import {PaymentAddComponent} from './payment-add/payment-add.component';
import {PaymentDetailsComponent} from './payment-details/payment-details.component';
import {PaymentSuccessComponent} from './payment-success/payment-success.component';
import {PaymentErrorComponent} from './payment-error/payment-error.component';

const authRoutes: Routes = [
  {
    path: 'payment/add', component: PaymentAddComponent, canActivate: [AuthGuard]
  },
  {
    path: 'payment/add/:type', component: PaymentAddComponent, canActivate: [AuthGuard]
  },
  {
    path: 'payment/detail/:id', component: PaymentDetailsComponent, canActivate: [AuthGuard]
  },
  {
    path: 'payment/success/:id', component: PaymentSuccessComponent
  },
  {
    path: 'payment/error/:id', component: PaymentErrorComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(authRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class PaymentRoutingModule {}
